/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import BenchlingCollection from 'BenchlingCollection';
import {Tag} from 'folder-items/FileConstants';

import TagModel, {TagAttributes} from './Tag';

class Tags extends BenchlingCollection<TagModel, TagAttributes> {
  attributeName!: string;

  constructor(
    models?: Array<TagModel> | Array<Partial<TagAttributes>>,
    options?: Backbone.Parseable & {sequenceID?: number}
  ) {
    super(models, options);
  }

  static initClass(): void {
    this.prototype.model = TagModel;
    this.prototype.attributeName = 'tags';
  }

  override initialize(models: Array<Tag>, options: {sequenceID: number}): void {
    super.initialize(models, options);
    this.on('change add remove', function (this: Tags): void {
      this.trigger('change:tags');
    });
  }
}
Tags.initClass();

export default Tags;
